import React from "react"
import "./howItWorks.scss"

const STEPS = [
  {
    number: "1",
    title: "Register Online",
    desc: "Fill out the free cab driver registration form with your name, mobile, city, and vehicle details.",
    time: "2 min",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="8.5" cy="7" r="4" /><line x1="20" y1="8" x2="20" y2="14" /><line x1="23" y1="11" x2="17" y2="11" />
      </svg>
    ),
    details: ["Name & mobile number", "Select your city", "Choose vehicle type"],
  },
  {
    number: "2",
    title: "Upload & Get Verified",
    desc: "Submit your driving license, vehicle RC, insurance, and ID proof. Our team verifies within 24 hours.",
    time: "24 hrs",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="12" y1="18" x2="12" y2="12" /><line x1="9" y1="15" x2="15" y2="15" />
      </svg>
    ),
    details: ["Driving license (LMV/Transport)", "Vehicle RC & insurance", "Aadhaar & PAN card"],
  },
  {
    number: "3",
    title: "Attach Car & Start Earning",
    desc: "Go online on the Pulpit Partner app, accept your first ride, and start earning from day one.",
    time: "Day 1",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" /><path d="M8 14s1.5 2 4 2 4-2 4-2" /><line x1="9" y1="9" x2="9.01" y2="9" /><line x1="15" y1="9" x2="15.01" y2="9" />
      </svg>
    ),
    details: ["Go online anytime", "Accept ride requests", "Earn on every trip"],
  },
]

const HowItWorks = () => {
  return (
    <section className="how-it-works">
      <div className="how-it-works__container">
        <h2 className="how-it-works__heading">
          How to <span>Join</span> as a Cab Driver
        </h2>
        <p className="how-it-works__subheading">
          Attach your car and start earning in 3 simple steps
        </p>

        <div className="how-it-works__timeline">
          {STEPS.map((step, i) => (
            <div className="how-it-works__item" key={i}>
              {/* Timeline rail */}
              <div className="how-it-works__rail">
                <div className="how-it-works__dot">
                  <span>{step.number}</span>
                </div>
                {i < STEPS.length - 1 && <div className="how-it-works__line" />}
              </div>

              {/* Content card */}
              <div className="how-it-works__card">
                <div className="how-it-works__card-header">
                  <div className="how-it-works__card-icon">{step.icon}</div>
                  <div>
                    <h3 className="how-it-works__card-title">{step.title}</h3>
                    <p className="how-it-works__card-desc">{step.desc}</p>
                  </div>
                  <span className="how-it-works__time-badge">{step.time}</span>
                </div>
                <ul className="how-it-works__checklist">
                  {step.details.map((d, j) => (
                    <li key={j}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#21A5A0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12" />
                      </svg>
                      {d}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default HowItWorks
